import React, { useMemo } from 'react'
import { createTheme, darken, lighten, ThemeProvider } from '@material-ui/core'

import useAuthTraining from 'hooks/useAuthTraining'

import TrainingPortalThemeContext from 'contexts/TrainingPortalThemeContext'
import PortalLoadingScreen from 'views/Guests/components/PortalLoadingScreen'
import defaultTheme from 'theme'

const TrainingPortalThemeProvider = ({ children }) => {
  const { loaded, theme: clientPortalTheme } = useAuthTraining()

  const theme = useMemo(() => {
    if (!clientPortalTheme) return defaultTheme

    const primaryColor =
      clientPortalTheme.primaryColor || defaultTheme.palette.primary.main
    const secondaryColor =
      clientPortalTheme.secondaryColor || defaultTheme.palette.secondary.main

    return createTheme(defaultTheme, {
      palette: {
        primary: {
          main: primaryColor,
          light: lighten(primaryColor, 0.9),
          dark: darken(primaryColor, 0.3),
          hover: darken(primaryColor, 0.2),
          contrastText: clientPortalTheme.primaryFontColor,
        },
        secondary: {
          main: secondaryColor,
          light: lighten(secondaryColor, 0.9),
          dark: darken(secondaryColor, 0.3),
          hover: darken(secondaryColor, 0.2),
          contrastText: clientPortalTheme.primaryFontColor,
        },
      },
    })
  }, [clientPortalTheme])

  const contextValue = useMemo(
    () => ({ clientPortalTheme }),
    [clientPortalTheme],
  )

  if (!loaded) {
    return <PortalLoadingScreen />
  }

  return (
    <TrainingPortalThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </TrainingPortalThemeContext.Provider>
  )
}

export default TrainingPortalThemeProvider
